/* eslint-disable */
import axios from 'axios'
import md5 from 'blueimp-md5'
import { getSearchString } from '../components/index'

/**
 * 生成随机或者指定位数的英文数字组合
 * @param {boolean} randomFlag	是否是随机生成位数
 * @param {number} min 			生成随机位数的最小数
 * @param {number} max			生成随机位数的最大数
 * @return {string}				返回生成的英文数字组合
 */
const randomWord = (randomFlag, min, max) => {
  let str = '',
    range = min,	// 默认赋值为第二个参数，如果是随机产生位数会通过下面的if改变。
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min;
  }
  for (let i = 0; i < range; i++) {
    let index = Math.round(Math.random() * (arr.length - 1));
    str += arr[index];
  }
  return str;
}
// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 50000 // 请求超时时间
})
service.interceptors.request.use(config => {
  config.headers['x-time'] = Math.round(new Date().getTime()/1000)
  config.headers['x-uid'] = randomWord(false, 16)
  config.headers['x-sign'] = md5('WV^86Q&!' + config.headers['x-time'] + config.headers['x-uid'])
  return config
}, error => {
  return Promise.reject(error)
})
export default service



// WEBPACK FOOTER //
// ./src/utils/http.js